module.exports = __webpack_public_path__ + "img/life_tit.fec2a419.jpg";